import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDirtyForm } from "../DirtyFormContext";

export const useUnsavedChangesNavigation = () => {
  const { isFormDirty, setFormDirty, formRef } = useDirtyForm();
  const [showModal, setShowModal] = useState(false);
  const [redirectRoute, setRedirectRoute] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleNavigation = (e: React.MouseEvent, route: string) => {
    if (isFormDirty) {
      e.preventDefault();
      setRedirectRoute(route);
      setShowModal(true);
    } else {
      navigate(route);
    }
  };

  const handleSaveChanges = () => {
    setFormDirty(false);
    setShowModal(false);
    formRef.current?.handleSubmit();
  };

  const handleLeave = () => {
    if (redirectRoute) {
      setFormDirty(false);
      setShowModal(false);
      navigate(redirectRoute);
    }
  };

  return {
    handleNavigation,
    handleSaveChanges,
    handleLeave,
    showModal,
    setShowModal,
  };
};
